<template>
  <div id="IndexTemisCivil_div">
    <menusuperior titulo="Temis Civil" subtitulo="MANEJO, CONTROL Y CONSULTA DE MATERIA CIVIL"></menusuperior>
    <menuizquierda></menuizquierda>

    <div v-if="$route.fullPath == RUTA_RAIZ_SISTEMA" class="d-flex justify-content-center align-items-center content-area">
      <div id="secciondebienvenidaTC" class="d-flex flex-wrap align-items-center justify-content-center">
        <figure class="text-center">
          <img src="../../../assets/logo-pj-transparente-blanco.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
        </figure>
        <h2>BIENVENIDOS AL SISTEMA TEMIS CIVIL</h2>
        <h4></h4>
      </div>
    </div>

    <div v-show="$route.fullPath != RUTA_RAIZ_SISTEMA" class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/TemisCivil/Comun/MenuIzquierda.vue'
  import comun from '@/../static/js/comun'

  export default {
    name: `Plantilla`,
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda
    },
    data() {
      return {
        RUTA_RAIZ_SISTEMA: '/TemisCivil'
      }
    }
  }
</script>

<style scoped>
  #secciondebienvenidaTC {
    width: 40vw;
    height: 600px;
    align-content: center;
  }

  #secciondebienvenidaTC h2 {
    margin-top: 3vh;
    text-align: center;
  }

  #secciondebienvenidaTC h4 {
    margin-top:1vh;
  }

  @media (max-width: 991px) {
    #secciondebienvenidaTC h2 {
      font-size: .9rem;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/TemisCivil/Comun/Plantilla.vue